// Iter BC — request a password reset link.
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, MailCheck } from "lucide-react";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setSent(true);
    } catch {
      toast.error("Something went wrong — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-paper-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <div className="text-center mb-8" data-testid={sent ? "forgot-sent-confirmation" : "forgot-request-form-header"}>
          <span className="w-12 h-12 rounded-2xl bg-sage-100 text-sage-700 inline-flex items-center justify-center mb-4">
            {sent ? <MailCheck className="w-5 h-5" strokeWidth={1.5} /> : <KeyRound className="w-5 h-5" strokeWidth={1.5} />}
          </span>
          <h1 className="font-heading text-3xl text-ink-900 mb-2">{sent ? "Check your email" : "Forgot your password?"}</h1>
          <p className="text-ink-500 text-sm">
            {sent
              ? "If an account exists for that email, we've sent a reset link. It's valid for 1 hour."
              : "Enter your account email and we'll send you a link to reset it."}
          </p>
        </div>
        {!sent ? (
          <form onSubmit={submit} className="space-y-3 bg-white border border-paper-200 rounded-3xl p-6 sm:p-8">
            <input
              data-testid="forgot-email-input"
              required
              type="email"
              placeholder="you@clinic.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full min-h-[48px] px-4 rounded-2xl bg-white border border-paper-200 focus:ring-2 focus:ring-sage-500/30 focus:border-sage-500 outline-none text-ink-900"
            />
            <button data-testid="forgot-submit-btn" type="submit" disabled={busy} className="w-full min-h-[52px] rounded-full bg-sage-500 hover:bg-sage-600 disabled:opacity-50 text-white font-medium transition-all">
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        ) : (
          <div className="hidden" />
        )}
        <div className="text-center mt-6">
          <Link to="/login" data-testid="back-to-login-link" className="text-sm text-ink-700 underline underline-offset-4">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
